import type React from 'react';

import { Alert, FormField, Input, Label } from '@zillow/constellation-10';

import type { Section } from '../../../models/index';
import { UTILITIES_INFORMATION } from '../../../constants';
import PhoneInput from '../../Widgets/PhoneInput';

type Props = {
  section: Section;
  setSectionValues: (keyValuePairs: object) => void;
};

export default function UtilitiesInformation({ section, setSectionValues }: Props): JSX.Element {
  function onElectricityPhoneNumberChange(event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) {
    const { value } = event.currentTarget;

    setSectionValues({
      [UTILITIES_INFORMATION.FIELD_NAME.ELECTRICITY_PHONE_NUMBER]: value,
    });
  }

  function setElectricityServiceProvider(event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>): void {
    setSectionValues({
      [UTILITIES_INFORMATION.FIELD_NAME.ELECTRICITY_SERVICE_PROVIDER]: event.currentTarget.value,
    });
  }

  function onWaterSewerPhoneNumberChange(event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) {
    const { value } = event.currentTarget;

    setSectionValues({
      [UTILITIES_INFORMATION.FIELD_NAME.WATER_SEWER_PHONE_NUMBER]: value,
    });
  }

  function setWaterSewerServiceProvider(event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>): void {
    setSectionValues({
      [UTILITIES_INFORMATION.FIELD_NAME.WATER_SEWER_SERVICE_PROVIDER]: event.currentTarget.value,
    });
  }

  function onTrashRemovalPhoneNumberChange(event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) {
    const { value } = event.currentTarget;

    setSectionValues({
      [UTILITIES_INFORMATION.FIELD_NAME.TRASH_REMOVAL_PHONE_NUMBER]: value,
    });
  }

  function setTrashRemovalServiceProvider(event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>): void {
    setSectionValues({
      [UTILITIES_INFORMATION.FIELD_NAME.TRASH_REMOVAL_SERVICE_PROVIDER]: event.currentTarget.value,
    });
  }

  return (
    <>
      <Alert>All utility provider information is required even if the utility won’t be paid by the tenant</Alert>
      <FormField
        required
        css={{ marginTop: 'layout.tight', marginBottom: 'layout.tight' }}
        label={<Label>Electricity service provider</Label>}
        control={
          <Input
            value={section.getFieldValue(UTILITIES_INFORMATION.FIELD_NAME.ELECTRICITY_SERVICE_PROVIDER)}
            onChange={setElectricityServiceProvider}
          />
        }
      />
      <FormField
        required
        css={{ marginBottom: 'layout.tight' }}
        label={<Label>Electricity service provider’s number</Label>}
        control={
          <PhoneInput
            value={section.getFieldValue(UTILITIES_INFORMATION.FIELD_NAME.ELECTRICITY_PHONE_NUMBER)}
            onChange={onElectricityPhoneNumberChange}
          />
        }
      />
      <FormField
        required
        css={{ marginBottom: 'layout.tight' }}
        label={<Label>Water/sewer service provider</Label>}
        control={
          <Input
            value={section.getFieldValue(UTILITIES_INFORMATION.FIELD_NAME.WATER_SEWER_SERVICE_PROVIDER)}
            onChange={setWaterSewerServiceProvider}
          />
        }
      />
      <FormField
        required
        css={{ marginBottom: 'layout.tight' }}
        label={<Label>Water/sewer service provider’s number</Label>}
        control={
          <PhoneInput
            value={section.getFieldValue(UTILITIES_INFORMATION.FIELD_NAME.WATER_SEWER_PHONE_NUMBER)}
            onChange={onWaterSewerPhoneNumberChange}
          />
        }
      />
      <FormField
        required
        css={{ marginBottom: 'layout.tight' }}
        label={<Label>Trash removal service provider</Label>}
        control={
          <Input
            value={section.getFieldValue(UTILITIES_INFORMATION.FIELD_NAME.TRASH_REMOVAL_SERVICE_PROVIDER)}
            onChange={setTrashRemovalServiceProvider}
          />
        }
      />
      <FormField
        required
        css={{ marginBottom: 'layout.tight' }}
        label={<Label>Trash removal service provider’s number</Label>}
        control={
          <PhoneInput
            value={section.getFieldValue(UTILITIES_INFORMATION.FIELD_NAME.TRASH_REMOVAL_PHONE_NUMBER)}
            onChange={onTrashRemovalPhoneNumberChange}
          />
        }
      />
    </>
  );
}
